import {Container} from "@mui/material";
//@ts-ignore
import logo from "../assets/BigLogoVertical.png";

interface WithLogoAndSelectLanguageWrapperProps {
    children: React.ReactNode;
}

const WithLogoAndSelectLanguageWrapper: React.FC<WithLogoAndSelectLanguageWrapperProps> = ({children}) => {
    return (
            <Container>
                <div style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                    <img src={logo} style={{transform: "scale(0.7)"}}/>
                    {children}
                </div>
            </Container>
    )
}

export default WithLogoAndSelectLanguageWrapper;